import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-facet-panel.css.lit';
import { OutlineAccordionPanel } from 'src/components/base/outline-accordion-panel/outline-accordion-panel';
import { MobileController } from 'src/components/controllers/mobile-controller';

/**
 * The IdbFacetPanel component
 * @element idb-facet-panel
 *
 * @slot heading - slot for panel heading
 * @slot defaultSlot - slot for panel content
 */
@customElement('idb-facet-panel')
export class IdbFacetPanel extends OutlineAccordionPanel {
  private mController = new MobileController(this);

  static styles: CSSResultGroup = [
    OutlineAccordionPanel.styles,
    componentStyles,
  ];

  connectedCallback() {
    super.connectedCallback();
    this.active = true;
  }

  render(): TemplateResult {
    const isMobile = this.mController.isMobile ? 'mobile' : null;
    const isActive = this.active ? 'active' : 'inactive';

    return html`
      <div class="facet-panel">
        <button
          class="accordion-button facet-button ${isMobile} ${isActive}"
          id="${this.id}-button"
          aria-expanded=${this.active}
          aria-controls="${this.id}-info"
          @click=${this.setActive}
        >
          <span class="facet-label ${isMobile}">
            <slot name="heading"> </slot>
          </span>
          <span class="accordion-icon facet-icon ${isMobile} ${isActive}">
            <idb-icon
              class=${isActive}
              icon='chevron-down'
              size="20px"
            ></idb-icon>
          </span>
        </button>
        <div
          class="facet-content ${isMobile}"
          role="region"
          aria-labelledby="${this.id}-button"
          id="${this.id}-info"
          aria-hidden="${!this.active}"
        >
          <slot></slot>
      </div>
    </div>`;
  }
}
